export default "__VITE_ASSET__sdObQO_f__"